import React, {Component} from 'react';
import {View, Platform} from 'react-native';
import {Provider} from 'mobx-react';
import PrimaryNav from './src/navigations/PrimaryNav';
import {appStyles} from './src/theme/styles';
import AppStore from './src/utils/AppStore';
import {refreshToken} from './src/utils/api';
import {createUser, getUser} from './src/database/UserDal';
import {NavigationContainer} from '@react-navigation/native';
import * as Font from 'expo-font';
import {blueDarkColor} from "./src/theme/colors";

const config = {
    screens: {
        requestInfo: 'requestInfo/:id',
        main:{
            screens: {
                requestList: 'requestList'
            }
        }
    },
};
const linking = {
    prefixes: ['https://client.asandarman.ir/'],
    // prefixes: ['http://localhost:19006/'],
    config,
};
export default class App extends Component {
    constructor(props) {
        super(props)
        this.state = {
            notifictionData: null,
            routeName: '',
            waiting: true
        }
        Font.loadAsync({
            'IRANSansMobile': require('./assets/fonts/IRANSansMobile.ttf'),
        }).then(res => {

        }).catch(err => {

        });
    }


    render() {
        return (
            <Provider store={AppStore}>
                <View style={{
                    flex: 1,
                    backgroundColor: blueDarkColor,
                    paddingTop: Platform.OS === 'ios' ? 20 : 0,
                }}>

                    <View style={appStyles.container}>
                        <NavigationContainer linking={linking}>
                            <PrimaryNav/>
                        </NavigationContainer>
                    </View>
                </View>
            </Provider>
        );
    }

    componentDidMount() {
        if (getUser() != null) {
            refreshToken((isConnect, response) => {
                if (isConnect && response.isSuccess) {
                    console.log(response)
                    createUser(getUser()?.cellphone, response.data.token)

                }
            })
        }

    }


}

console.disableYellowBox = true
